import user  from './user'
import organization  from './organization'
import api  from './api'
import site  from './site'

const modules = {
        user,
        organization,
        api,
        site
    };
    
    // actions: {
    //     nuxtServerInit ({ commit }, { req }) {
    //       if (req.session.user) {
    //         commit('user', req.session.user)
    //       }
    //     }
    // async nuxtServerInit({ dispatch }) {
    //     await dispatch('core/load')
    //   }
    //  }


export default modules